// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3DOZe","notes":"Notes_notes__IiBUS","note":"Notes_note__3Oxnz","markdown":"Notes_markdown__1qcPu"};